"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _UserAvatar = _interopRequireDefault(require("../User/UserAvatar"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _classnames = _interopRequireDefault(require("classnames"));

var LikedUsers = function LikedUsers(_ref) {
  var likedUsers = _ref.likedUsers,
      previewCount = _ref.previewCount,
      isCurrentUserLiked = _ref.isCurrentUserLiked,
      anonymousLikesCount = _ref.anonymousLikesCount;
  var totalLikeBydUsers = likedUsers.length + anonymousLikesCount;
  var phrase = '';

  if (isCurrentUserLiked && totalLikeBydUsers === 1) {
    phrase = 'post.like.number.only_self';
  } else if (isCurrentUserLiked && totalLikeBydUsers > 1) {
    phrase = 'post.like.number.including_self';
  } else {
    phrase = 'post.like.number';
  }

  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('post-like-list', 'topic-liked-users', 'm-v')
  }, likedUsers.slice(0, previewCount).map(function (user) {
    return (0, _preact.h)(_UserAvatar.default, {
      key: user.id,
      user: user,
      extraClass: "avatar avatar--XS",
      disablePopup: true,
      showRank: false
    });
  }), (0, _preact.h)("span", {
    className: "topic-liked-users_text"
  }, (0, _preact.h)(_Tooltip.default, {
    withArrow: true,
    trigger: (0, _preact.h)(_phrase.default, {
      p: phrase,
      count: {
        numberOfLikes: isCurrentUserLiked ? (totalLikeBydUsers - 1).toString() : totalLikeBydUsers.toString()
      }
    }),
    tooltipMessage: (0, _preact.h)("ul", {
      className: "post-like-list__complete-list"
    }, likedUsers.map(function (likedUser) {
      return (0, _preact.h)("li", {
        className: "post-like-list__item",
        key: likedUser.id
      }, (0, _preact.h)("a", {
        className: "link",
        href: (0, _absoluteUrlRuntime.resolveUrl)(likedUser.url)
      }, (0, _preact.h)(_UserAvatar.default, {
        user: likedUser,
        extraClass: "avatar avatar--S",
        disablePopup: true,
        showRank: false
      }), (0, _preact.h)("span", null, likedUser.name)));
    }), anonymousLikesCount > 0 && (0, _preact.h)("li", {
      className: "post-like-list__item"
    }, (0, _preact.h)("div", {
      className: "wrapper"
    }, (0, _preact.h)(_UserAvatar.default, {
      user: {
        id: '',
        name: 'Anonymous',
        avatar: ''
      },
      extraClass: "avatar avatar--S",
      disablePopup: true,
      showRank: false
    }), (0, _preact.h)(_phrase.default, {
      p: "anonymous.users.count",
      count: {
        n: anonymousLikesCount
      },
      renderAsText: true
    }, function (anonymousLikes) {
      return (0, _preact.h)("span", null, anonymousLikes);
    }))))
  })));
};

var _default = LikedUsers;
exports.default = _default;